'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useEffect, useRef, useState } from 'react';
import { MessagePanel } from '~/components/MessagePanel/MessagePanel';
import useJourneyData from '~/hooks/useJourneyData';
import { useJourneyEditErrors } from '~/stores/journeyStore';
import { consumeOriginDateShiftNotice } from '~/utils/originDateShiftNotice';
import styles from './OriginDateShiftNotice.module.css';
type OriginDateShiftNoticeProps = {
  journeyId: string;
};
const OriginDateShiftNotice = t0 => {
  const $ = _c(7);
  const {
    journeyId
  } = t0;
  const t = useTranslations();
  const journeyEditErrors = useJourneyEditErrors();
  const {
    statusSummary
  } = useJourneyData();
  const hasConsumed = useRef(false);
  const [hasNotice, setHasNotice] = useState(false);
  let t1;
  let t2;
  if ($[0] !== journeyId) {
    t1 = () => {
      if (hasConsumed.current) {
        return;
      }
      hasConsumed.current = true;
      const notice = consumeOriginDateShiftNotice(journeyId);
      setHasNotice(notice?.messages.includes("DEPARTURE_DATE_CHANGED_FOR_ORIGIN") ?? false);
    };
    t2 = [journeyId];
    $[0] = journeyId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const hasBlockingError = journeyEditErrors.length > 0 || (statusSummary?.some(_temp) ?? false);
  if (!hasNotice || hasBlockingError) {
    return null;
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("content.feedback.origin_change_date_earlier");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className={styles.wrapper} data-test-id="origin-date-shift-notice-wrapper"><MessagePanel message={t3} status="info" dismissable={true} /></div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export { OriginDateShiftNotice };
function _temp(status) {
  return status.isUnavailable;
}